import { createContext, useContext, type ReactNode } from 'react';
import type { Template } from './tipos';

const TemplateContext = createContext<Template | null>(null);

export function TemplateProvider({ template, children }: { template: Template; children: ReactNode }) {
  return <TemplateContext.Provider value={template}>{children}</TemplateContext.Provider>;
}

/** O template da loja, ou `null` fora da vitrine (testes, telas de erro). */
export function useTemplate(): Template | null {
  return useContext(TemplateContext);
}
